import { Component, OnInit } from '@angular/core';
import {LanguageService} from "../../service/language.service";
import {TemplateService} from "../../common/service/template.service";

@Component({
  selector: 'app-privacy-content',
  templateUrl: './privacy-content.component.html',
  styleUrls: ['./privacy-content.component.scss'],
})
export class PrivacyContentComponent  implements OnInit {

  isLoading: boolean;
  content: string;

  constructor(private templateService: TemplateService) { }

  ngOnInit() {

    this.isLoading = true;

    this.templateService.getTemplateByCode("PRIVACY").subscribe(template => {
      this.content = LanguageService.getTranslation(template.body, 'description');
      this.isLoading = false;
    });

  }
}
